
export const LoginData = {
  Token:'',
  MenuIdx:[''],
  Account:'',
}


